import React from 'react';
import { Table } from 'antd';

const ResponsiveTableWrapper = ({ children, ...props }) => {
  return (
    <div className="responsive-table-wrapper">
      <Table 
        {...props}
        scroll={{ x: 'max-content', ...props.scroll }}
        pagination={{
          showSizeChanger: true,
          //showQuickJumper: true,
          showTotal: (total, range) => 
            `${range[0]}-${range[1]} of ${total} items`,
          ...props.pagination
        }}
      >
        {children}
      </Table>
    </div>
  );
};

export default ResponsiveTableWrapper;
